import OrderedList from "../../components/OrderedList"
import WizardFooter from "../../components/WizardFooter"
import SENDING from "../../images/sending.svg"

export interface GovtWizardTakeActionNextUpProps {
  handleResetContactView: () => void
  handleNext: () => void
}

const GovtWizardTakeActionNextUp = ({
  handleResetContactView,
  handleNext,
}: GovtWizardTakeActionNextUpProps) => (
  <div className="container max-w-[644px] pt-10 lg:pt-13 pb-[202px] sm:pb-31">
    <figure>
      <img src={SENDING} alt="sending" />
    </figure>

    <p className="text-dusk-500 text-sm text-center font-body font-extrabold leading-[120%] tracking-[0.84px] mt-6">
      You're almost there
    </p>

    <h1 className="text-charcoal-500 text-3xl text-center font-display font-medium leading-[124%] tracking-[0.6px] mt-2">
      Next up: Review your Plan Summary and start prepping resources
    </h1>

    <OrderedList
      list={[
        "We've saved your action plan to your NCX profile. You can access it easily from your Dashboard.",
        "You will have a prioritized task list of items needed for your NRCS visit. This will help your visit move quicker, and be more focused on achieving the right goal for you.",
        "Find your local NRCS office and get your forms ready to visit!",
      ]}
      className="mt-4"
      itemClass="!text-base !font-body !leading-[130%] !tracking-[0.32px]"
    />

    <WizardFooter scrollToBottom={false}>
      <div className="w-full sm:w-auto flex flex-col sm:flex-row gap-4 sm:ml-auto">
        <button
          type="button"
          className="govt-app-page-4-next-up-go-back-button btn2 btn2-outline-primary font-bold tracking-[0.32px]"
          onClick={handleResetContactView}
        >
          Go Back
        </button>

        <button
          type="button"
          className="govt-app-page-4-next-up-review-button btn2 btn2-primary font-bold tracking-[0.32px]"
          onClick={handleNext}
        >
          Review
        </button>
      </div>
    </WizardFooter>
  </div>
)

export default GovtWizardTakeActionNextUp
